// Remembers the URL a signed-out user tried to open so that finishing login
// lands them there instead of on the home page. localStorage on purpose: the
// email login link opens in a new tab, whose sessionStorage is empty.
const STORAGE_KEY = 'loginRedirectPath';

const isRestorable = (path: string): boolean =>
    path.startsWith('/') && path !== '/' && !path.startsWith('/auth/');

export function rememberLoginRedirect(path: string): void {
    try {
        if (isRestorable(path)) {
            localStorage.setItem(STORAGE_KEY, path);
        } else {
            localStorage.removeItem(STORAGE_KEY);
        }
    } catch {
        // Storage can be unavailable (private mode, blocked site data).
    }
}

/** Returns the remembered path (if any) and forgets it. */
export function consumeLoginRedirect(): string | null {
    try {
        const path = localStorage.getItem(STORAGE_KEY);
        if (path !== null) {
            localStorage.removeItem(STORAGE_KEY);
        }
        return path && isRestorable(path) ? path : null;
    } catch {
        return null;
    }
}
